import { Box, Button, Grid, Typography } from '@material-ui/core';
import React, { FC, useState } from 'react';
import { AuditListingProps } from 'src/types';
import { MobileAuditSerialsDialog } from './MobileAuditSerialsDialog';
import CreateOutlinedIcon from '@material-ui/icons/CreateOutlined';

export const ProductNameAndSerialNos: FC<AuditListingProps> = ({
  id,
  isSerialized,
  productName,
  scannedSerialNos
}) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const toggleSerialDialog = () => {
    setIsOpen(!isOpen);
  };

  return (
    <Grid
      item
      xs={12}
      style={{ paddingBottom: isSerialized ? '0' : '1em' }}
      container
    >
      {isSerialized ? (
        <>
          <Grid item xs={12} style={{ paddingBottom: '1em' }}>
            <Typography variant="body2">{productName}</Typography>
          </Grid>

          {scannedSerialNos?.[0] ? (
            <Grid item xs={12}>
              <Typography
                variant="overline"
                gutterBottom
                style={{ letterSpacing: 1 }}
              >
                Scanned Serials:
              </Typography>
              <Box
                p={1.5}
                border="1px solid #ddd"
                borderRadius={5}
                bgcolor="#fafafa"
              >
                <Box
                  display="flex"
                  alignItems="center"
                  style={{ gap: '1em' }}
                  overflow="hidden"
                >
                  <Typography
                    variant="body2"
                    style={{
                      flex: 1,
                      whiteSpace: 'nowrap',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis'
                    }}
                  >
                    {scannedSerialNos.join(', ')}
                  </Typography>

                  <Button
                    size="small"
                    startIcon={<CreateOutlinedIcon />}
                    onClick={toggleSerialDialog}
                  >
                    Edit
                  </Button>
                </Box>
              </Box>
            </Grid>
          ) : null}
        </>
      ) : (
        <>
          <Typography variant="body2">{productName}</Typography>
        </>
      )}
      <MobileAuditSerialsDialog
        open={isOpen}
        toggleOpen={toggleSerialDialog}
        scannedSerialNos={scannedSerialNos}
        productName={productName}
        id={id}
      />
    </Grid>
  );
};
